import { HTMLAttributes, memo } from 'react';
import styles from './index.module.less';
import classNames from 'classnames';

interface ILinearItemWrap extends HTMLAttributes<HTMLDivElement> {
  /**
   * 预设主题类型，方便多处复用的样式
   */
  theme?: 'default' | 'productBlack' | 'outOfStock';
  /**
   * 是否active，与theme配套使用比较佳
   */
  active?: boolean;
}

/**
 * 【渐变色圆角】背景框ItemWrap
 * @param {string} theme 'default' | 'productBlack' | 'outOfStock' 预设主题类型，为了避免多处复用
 * @param {boolean|string} active 与theme配套
 * @param {*} props onClick / className / style / key / id 等等
 */
function Index(props: ILinearItemWrap) {
  const { theme, active = false, ...resProps } = props;

  return (
    <div
      {...resProps}
      data-active={active}
      className={classNames(styles.item, theme && styles[theme], resProps.className)}
      style={resProps.style}
    >
      {props.children}
    </div>
  );
}

const LinearItemWrap = memo(Index);
export default LinearItemWrap;
